import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import SchengenService from '@/visa-application/services/schengen/schengen.service';
import DirectusService from '@/core/directus/directus.service';
import TMACMSModel from '@/visa-application/models/TMACMSModel';
import LanguageCode from '@/locale/language-code';
import { LOCAL_COUNTRY } from '@/constants';
import _ from 'lodash';

export interface TMAData {
  name: string;
  status: string;
  visible: boolean;
}

@Component
export default class TrackMyApplication extends Vue {
  @Prop() public formId: number;

  @Inject('directusService') private directusService: () => DirectusService;
  @Inject('schengenService') private schengenService: () => SchengenService;

  public cmsData: TMACMSModel = new TMACMSModel();
  public tmaData: TMAData[] = [];
  public success = ['yes', 'done', 'received'];
  public pending = ['pending'];
  public undone = ['no'];
  public attention = ['error', 'withdrawn', 'sent'];

  private unwatchCurrentLanguage: Function;

  public mounted(): void {
    this.getTMAFormData();
    this.unwatchCurrentLanguage = this.$store.watch(
      () => this.$store.getters.currentLanguage,
      currentLanguage => {
        this.getTranslationFromCMS(currentLanguage);
      },
      {
        immediate: true
      }
    );
  }

  public getTMAFormData(): void {
    if (this.formId !== undefined) {
      this.schengenService()
        .getTrackMyApplicationFormData(LOCAL_COUNTRY, this.formId)
        .then((result: TMAData[]) => {
          this.tmaData = result;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }

  public getTranslationFromCMS(currentLanguage: LanguageCode): void {
    this.directusService()
      .getCollection<TMACMSModel>(TMACMSModel, 'tma', ['translation.*'], undefined, currentLanguage)
      .then((result: TMACMSModel[]) => {
        this.cmsData = result[0];
      })
      .catch(error => {
        console.error(error);
      });
  }

  public getTMATranslate(tmaName) {
    const index = tmaName.indexOf(`_${LOCAL_COUNTRY}_`);
    tmaName = tmaName.slice(index + LOCAL_COUNTRY.length + 2);
    return _.get(this.cmsData, tmaName, tmaName);
  }

  public getTMAStatus(status: string): string {
    if (this.success.indexOf(status) !== -1) {
      return '-color-green';
    } else if (this.pending.indexOf(status) !== -1) {
      return '-color-yellow';
    } else if (this.undone.indexOf(status) !== -1) {
      return '-color-grey';
    } else if (this.attention.indexOf(status) !== -1) {
      return '-color-red';
    }
    return '-color-grey';
  }
}
